import { SITE } from "@/data/site";

export const organizationLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE.name,
    url: SITE.url,
    slogan: SITE.slogan,
    description: SITE.description,
    logo: `${SITE.url}/favicon.svg`,
    areaServed: "PL",
    sameAs: [],
};

export const softwareApplicationLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: SITE.name,
    applicationCategory: "FinanceApplication",
    operatingSystem: "iOS, Android",
    description: SITE.description,
    offers: {
        "@type": "Offer",
        price: "34.99",
        priceCurrency: "PLN",
    },
    inLanguage: "pl",
};

export const faqPageLd = (faq) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
});

export const productLd = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: `${SITE.name} PRO`,
    description: "Plan PRO aplikacji Groszownik: faktury bez limitu, KPiR autopilot, AI Doradca, OCR AI, VAT-OSS i auto QR ZUS/US.",
    brand: { "@type": "Brand", name: SITE.name },
    offers: {
        "@type": "Offer",
        price: "34.99",
        priceCurrency: "PLN",
        availability: "https://schema.org/InStock",
        url: `${SITE.url}/pricing`,
    },
};

export const breadcrumbLd = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.name,
        item: `${SITE.url}${it.path}`,
    })),
});

export const articleLd = (post) => ({
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    description: post.description,
    datePublished: post.date,
    dateModified: post.date,
    author: { "@type": "Organization", name: SITE.name },
    publisher: {
        "@type": "Organization",
        name: SITE.name,
        logo: { "@type": "ImageObject", url: `${SITE.url}/favicon.svg` },
    },
    mainEntityOfPage: `${SITE.url}/blog/${post.slug}`,
    inLanguage: "pl",
});
